import { render, staticRenderFns } from "./AppointBox.vue?vue&type=template&id=6406d74a&scoped=true"
import script from "./AppointBox.vue?vue&type=script&lang=js"
export * from "./AppointBox.vue?vue&type=script&lang=js"
import style0 from "./AppointBox.vue?vue&type=style&index=0&id=6406d74a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406d74a",
  null
  
)

export default component.exports